import {
  SIGNUP_SUCCESS,
  SIGNUP_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  ACTIVATION_SUCCESS,
  ACTIVATION_FAIL,
  RESEND_ACTIVATION_SUCCESS,
  RESEND_ACTIVATION_FAIL,
  SET_AUTH_LOADING,
  REMOVE_AUTH_LOADING,
  USER_LOADED_SUCCESS,
  USER_LOADED_FAIL,
  AUTHENTICATED_SUCCESS,
  AUTHENTICATED_FAIL,
  REFRESH_SUCCESS,
  REFRESH_FAIL,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_CONFIRM_SUCCESS,
  RESET_PASSWORD_CONFIRM_FAIL,
  LOGOUT,
} from "./types";
import { setAlert } from "./alert";
import axios from "axios";

export const check_authenticated = () => async (dispatch) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      token: localStorage.getItem("access"),
    });

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/jwt/verify/`,
        body,
        config
      );

      if (res.status === 200) {
        dispatch({
          type: AUTHENTICATED_SUCCESS,
        });
      } else {
        dispatch({
          type: AUTHENTICATED_FAIL,
        });
      }
    } catch (err) {
      dispatch({
        type: AUTHENTICATED_FAIL,
      });
    }
  } else {
    dispatch({
      type: AUTHENTICATED_FAIL,
    });
  }
};

export const signup = (first_name, last_name, email, password, re_password) => async (dispatch) => {
  dispatch({
    type: SET_AUTH_LOADING,
  });

  const config = {
    headers: {
    "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({
    first_name,
    last_name,
    email,
    password,
    re_password,
  });

  try {
    const res = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/users/`,
    body,
    config
    );

    if (res.status === 201) {
    dispatch({
      type: SIGNUP_SUCCESS,
      payload: res.data,
    });
    dispatch(
      setAlert(
      "We have sent you an email, please activate your account. Check the spam folder",
      "green"
      )
    );
    } else {
    dispatch({
      type: SIGNUP_FAIL,
    });
   
    }

    dispatch({
    type: REMOVE_AUTH_LOADING,
    });
    return {
    status: res.status,
    data: res.data,
    };
  } catch (err) {
    dispatch({
    type: SIGNUP_FAIL,
    });
    dispatch({
    type: REMOVE_AUTH_LOADING,
    });

    if (err.response) {


    return {
      status: err.response.status,
      data: err.response.data,
    };
    } else {
    dispatch(
      setAlert(
      "Error connecting to the server, please try again later.",
      "red"
      )
    );
    return {
      status: 500,
      data: { error: "Connection error" },
    };
    }
  }
};

export const load_user = () => async (dispatch) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/users/me/`,
        config
      );

      if (res.status === 200) {
        dispatch({
          type: USER_LOADED_SUCCESS,
          payload: res.data,
        });
      } else {
        dispatch({
          type: USER_LOADED_FAIL,
        });
      }
    } catch (err) {
      dispatch({
        type: USER_LOADED_FAIL,
      });
    }
  } else {
    dispatch({
      type: USER_LOADED_FAIL,
    });
  }
};

export const login = (email, password) => async dispatch => {
  dispatch({
    type: SET_AUTH_LOADING,
  });

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const body = JSON.stringify({
    email,
    password,
  });

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/jwt/create/`,
      body,
      config
    );

    if (res.status === 200) {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data,
      });
      dispatch(load_user());
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      dispatch(setAlert('Login successful', 'green'));
      return {
        status: res.status,
        data: res.data,
      };
    } else {
      dispatch({
        type: LOGIN_FAIL,
      });
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      dispatch(setAlert('Error logging in.', 'red'));
      return {
        status: res.status,
        data: res.data,
      };
    }
  } catch (err) {
    dispatch({
      type: LOGIN_FAIL,
    });
    dispatch({
      type: REMOVE_AUTH_LOADING,
    });

    if (err.response) {
      dispatch(setAlert('Error logging in.', 'red'));
      return {
        status: err.response.status,
        data: err.response.data,
      };
    } else {
      dispatch(setAlert('Error logging in. Try again later', 'red'));
      return {
        status: 500,
        data: { error: 'Connection error' },
      };
    }
  }
};

export const googleAuthenticate = (state, code) => async dispatch => {
  if (state && code && !localStorage.getItem('access')) {
      const config = {
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
          }
      };

      const details = {
          'state': state,
          'code': code
      };

      const formBody = Object.keys(details).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(details[key])).join('&');

      try {
          const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/o/google-oauth2/?${formBody}`, config);

          dispatch({
              type: LOGIN_SUCCESS,
              payload: res.data
          });

          dispatch(load_user());
          dispatch(setAlert('Login successful', 'green'));
      } catch (err) {
          dispatch({
              type: LOGIN_FAIL
          });
          dispatch(setAlert('Error logging in.', 'red'));
      }
  }
};

export const microsoftAuthenticate = (state, code) => async dispatch => {
  if (state && code && !localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    const details = {
      state: state,
      code: code
    };

    const formBody = Object.keys(details)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(details[key]))
      .join('&');

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/o/azuread-oauth2/`,
        formBody,
        config
      );

      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data
      });

      dispatch(load_user());
      dispatch(setAlert('Login successful', 'green'));
    } catch (err) {
      dispatch({
        type: LOGIN_FAIL
      });
      dispatch(setAlert('Error logging in.', 'red'));
    }
  }
};


export const activate = (uid, token) => async (dispatch) => {
  dispatch({
    type: SET_AUTH_LOADING,
  });

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const body = JSON.stringify({
    uid,
    token,
  });

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/users/activation/`,
      body,
      config
    );

    dispatch({
      type: REMOVE_AUTH_LOADING,
    });

    if (res.status === 204) {
      dispatch({
        type: ACTIVATION_SUCCESS,
      });
      dispatch(setAlert('Account activated successfully', 'green'));
      return {
        status: res.status,
        data: res.data,
      };
    } else {
      dispatch({
        type: ACTIVATION_FAIL,
      });
      dispatch(setAlert('Error activating account', 'red'));
      return {
        status: res.status,
        data: res.data,
      };
    }
  } catch (err) {
    dispatch({
      type: ACTIVATION_FAIL,
    });
    dispatch({
      type: REMOVE_AUTH_LOADING,
    });

    if (err.response) {
      dispatch(setAlert('Error activating account', 'red'));
      return {
        status: err.response.status,
        data: err.response.data,
      };
    } else {
      dispatch(
        setAlert('Error connecting to the server, please try again later.', 'red')
      );

      return {
        status: 500,
        data: { error: 'Connection error' },
      };
    }
  }
};

export const resend_activation = email => async dispatch => {
  dispatch({
    type: SET_AUTH_LOADING,
  });

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const body = JSON.stringify({ email });

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/users/resend_activation/`,
      body,
      config
    );

    dispatch({
      type: REMOVE_AUTH_LOADING,
    });

    if (res.status === 204) {
      dispatch({
        type: RESEND_ACTIVATION_SUCCESS,
      });
      dispatch(
        setAlert('Activation email sent successfully!', 'green')
      );
      return {
        status: res.status,
        data: res.data,
      };
    } else {
      dispatch({
        type: RESEND_ACTIVATION_FAIL,
      });
      dispatch(setAlert('Error sending activation email.', 'red'));
      return {
        status: res.status,
        data: res.data,
      };
    }
  } catch (err) {
    dispatch({
      type: RESEND_ACTIVATION_FAIL,
    });
    dispatch({
      type: REMOVE_AUTH_LOADING,
    });

    if (err.response) {
      dispatch(setAlert('Error sending activation email.', 'red'));
      return {
        status: err.response.status,
        data: err.response.data,
      };
    } else {
      dispatch(
        setAlert('Error connecting to the server, please try again later.', 'red')
      );
      return {
        status: 500,
        data: { error: 'Connection error' },
      };
    }
  }
};

export const refresh = () => async (dispatch) => {
  if (localStorage.getItem("refresh")) {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      refresh: localStorage.getItem("refresh"),
    });

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/jwt/refresh/`,
        body,
        config
      );

      if (res.status === 200) {
        dispatch({
          type: REFRESH_SUCCESS,
          payload: res.data,
        });
      } else {
        dispatch({
          type: REFRESH_FAIL,
        });
      }
    } catch (err) {
      dispatch({
        type: REFRESH_FAIL,
      });
    }
  } else {
    dispatch({
      type: REFRESH_FAIL,
    });
  }
};

export const reset_password = (email) => async (dispatch) => {
  dispatch({
    type: SET_AUTH_LOADING,
  });

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email });

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/users/reset_password/`,
      body,
      config
    );

    if (res.status === 204) {
      dispatch({
        type: RESET_PASSWORD_SUCCESS,
      });
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      dispatch(setAlert("We have sent an email to reset your password!", "green"));
    } else {
      dispatch({
        type: RESET_PASSWORD_FAIL,
      });
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      dispatch(setAlert("Error sending password reset email", "red"));
    }
  } catch (err) {
    dispatch({
      type: RESET_PASSWORD_FAIL,
    });
    dispatch({
      type: REMOVE_AUTH_LOADING,
    });
    dispatch(setAlert("Error sending password reset email", "red"));
  }
};

export const reset_password_confirm = (uid, token, new_password, re_new_password) => async (dispatch) => {
    dispatch({
      type: SET_AUTH_LOADING,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      uid,
      token,
      new_password,
      re_new_password,
    });

    if (new_password !== re_new_password) {
      dispatch({
        type: RESET_PASSWORD_CONFIRM_FAIL,
      });
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      dispatch(setAlert("Passwords do not match", "red"));
    } else {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/users/reset_password_confirm/`,
          body,
          config
        );

        if (res.status === 204) {
          dispatch({
            type: RESET_PASSWORD_CONFIRM_SUCCESS,
          });
          dispatch({
            type: REMOVE_AUTH_LOADING,
          });
          dispatch(setAlert("Password has been reset successfully", "green"));
        } else {
          dispatch({
            type: RESET_PASSWORD_CONFIRM_FAIL,
          });
          dispatch({
            type: REMOVE_AUTH_LOADING,
          });
          dispatch(setAlert("Error resetting your password", "red"));
        }
      } catch (err) {
        dispatch({
          type: RESET_PASSWORD_CONFIRM_FAIL,
        });
        dispatch({
          type: REMOVE_AUTH_LOADING,
        });
        dispatch(setAlert("Error resetting your password", "red"));
      }
    }
  };

export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT,
  });
  dispatch(setAlert("You have logged out successfully!", "green"));
};
